import { Injectable } from '@angular/core';
import { setProps } from '@ngneat/elf';
import { trophies$, trophiesStore } from './trophies.store';
import { UserTrophies } from '@app/home/trophies/trophies.model';

@Injectable({ providedIn: 'root' })
export class TrophiesRepository {
  readonly all$ = trophies$;

  setTrophies(trophies: UserTrophies[]): void {
    trophiesStore.update(setProps({ items: trophies }));
  }

  reset(): void {
    trophiesStore.reset();
  }

  getTrophies(): UserTrophies[] {
    return trophiesStore.getValue().items;
  }
}
